export const FETCH_SCREENSAVER = 'SCREENSAVER/FETCH_REQUEST';
export const FETCH_SCREENSAVER_SUCCESS = 'SCREENSAVER/FETCH_SUCCESS';

export const FETCH_SCREENSAVERS = 'SCREENSAVERS/FETCH_REQUEST';
export const FETCH_SCREENSAVERS_SUCCESS = 'SCREENSAVERS/FETCH_SUCCESS';

export const FETCH_AVAILABLE_SCREENSAVERS = 'SCREENSAVERS/FETCH_AVAILABLE_REQUEST';
export const FETCH_AVAILABLE_SCREENSAVERS_SUCCESS = 'SCREENSAVERS/FETCH_AVAILABLE_SUCCESS';

export const CREATE_SCREENSAVER = 'SCREENSAVER/CREATE_REQUEST';
export const CREATE_SCREENSAVER_SUCCESS = 'SCREENSAVER/CREATE_SUCCESS';

export const UPDATE_SCREENSAVER = 'SCREENSAVER/UPDATE_REQUEST';
export const UPDATE_SCREENSAVER_SUCCESS = 'SCREENSAVER/UPDATE_SUCCESS';

export const DELETE_SCREENSAVER = 'SCREENSAVER/DELETE_REQUEST';
export const DELETE_SCREENSAVER_SUCCESS = 'SCREENSAVER/DELETE_SUCCESS';

export const CLONE_SCREENSAVER = 'SCREENSAVER/CLONE_REQUEST';
export const CLONE_SCREENSAVER_SUCCESS = 'SCREENSAVER/CLONE_SUCCESS';

export const PREVIEW_TOKEN_SCREENSAVER = 'SCREENSAVER/PREVIEW_TOKEN_REQUEST';

// Filters
export const SET_SCREENSAVERS_DASHBOARD_FILTER = 'SCREENSAVERS/DASHBOARD/FILTER/SET';
export const CLEAR_SCREENSAVERS_DASHBOARD_FILTER = 'SCREENSAVERS/DASHBOARD/FILTERS/CLEAR';

export const SCREENSAVER_READY = 'SCREENSAVER/READY';
